<template>

  <div v-if="form">
    <el-form v-for="(f, i) in form" :key="i">
      <span v-for="(fr, ri) in f.children" :key="ri">
        <span v-for="(fc, ci) in fr.children" :key="ci">

        <component :is="f.dataType" v-bind="f" v-model="f.value"
          :type="f.type ? f.type : null"
          :url="f.dataType === 'file-upload' ? (f.url ? f.url : null) : null" />
        </span>
     </span>

    </el-form>
  </div>

</template>

<script>

import ArrayMixins from '@/mixins/ArrayMixins'

export default {
  name: 'form-viewer',

  mixins: [ArrayMixins],

  props: {
    value: {
      required: true
    }
  },



  methods: {


    isLayout (f) {
      return this.isRow(f) || this.isCol(f)
    },


    isRow (f) {

      if (f) {
        return f.dataType === 'el-row'
      }

      return false
    },


    isCol (f) {

      if (f) {
        return f.dataType === 'el-col'
      }

      return false
    },



    makeChildren (form) {
      let formArray = []

      let row = []
      let col = []

      let rowCount = -1
//      let colCount = -1

      for (let f in form) {

        if (this.isRow(form[f])) {

           form[f].id = 'ROW-' + f
           form[f].children = []
           row.push(form[f])

           console.log('row', row, form[f], 'f', f)

           if (rowCount >= 0) {
             row[rowCount].children.push(col)

             rowCount = -1
//             colCount = -1

             row = []
             col = []
           }

           rowCount += 1

        }

        if (this.isCol(form[f])) {

          form[f].id = 'COl-' + f

          form[f].children = []
          col.push(form[f])

          console.log('col', col, 'form[f]', form[f], 'rowCount', rowCount)

        } /* else {
          form[f].id = 'COMP-' + f
          col[colCount].children.push(form[f])
        }
        colCount += 1


       if (col.length >= 1) {
          col[colCount].children.push(form[f])

        } else {

          formArray.push(form[f])

        }
*/
        }  // for


      formArray.push(row)

      return formArray
      }

  },



  data () {
    return {
//      form: this.makeChildren(this.value)
      form: this.value
    }
  }

}

</script>
